import { createAction } from 'redux-actions';

import { BI_SISU_EVENT, AuthMode } from './bi';
import {
  BiData,
  TopicsOnboardingDoneBiEvent,
  TopicsOnboardingShowBiEvent,
} from '@wix/da-bi/pkg/events';

export const screenLoaded = createAction(BI_SISU_EVENT, (authMode: AuthMode) =>
  BiData<TopicsOnboardingShowBiEvent>({
    evid: 235,
    view: 'login',
    component: 'onboarding',
    auth_mode: authMode,
  })
);

export const clickContinue = createAction(BI_SISU_EVENT, (authMode: AuthMode) =>
  BiData<TopicsOnboardingDoneBiEvent>({
    evid: 237,
    view: 'login',
    component: 'onboarding',
    auth_mode: authMode,
  })
);
